import { GET_MENU_BY_ID, SAVE_MENU, SEND_QUERY } from "./apiEndpoints";

export const fetchMenuById = async (menuId, frontendPath) => {
  const hasAdmin = frontendPath.includes("admin");
  const token = localStorage.getItem("authToken");
  const response = await fetch(GET_MENU_BY_ID(menuId), {
    method: "GET",
    headers: {
      "Admin-Request": hasAdmin,
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error("Failed to fetch the menu");
  }
  return response.json();
};

export const saveMenu = async (menu, frontendPath, restaurantId) => {
  if (!restaurantId) {
    throw new Error("Missing restaurant ID");
  }

  const hasAdmin = frontendPath.includes("admin");
  const token = localStorage.getItem("authToken");
  const response = await fetch(SAVE_MENU, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Admin-Request": hasAdmin,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ restaurantId: restaurantId, ...menu }),
  });
  if (!response.ok) {
    throw new Error("Failed to save the menu");
  }
  return response.json();
};

export const sendQuery = async (menuId, frontendPath, query) => {
  const hasAdmin = frontendPath.includes("admin");
  const token = localStorage.getItem("authToken");
  const response = await fetch(SEND_QUERY(menuId, query), {
    method: "GET",
    headers: {
      "Admin-Request": hasAdmin,
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error(`Failed to send query. ${response.statusText}`);
  }
  const data = await response.text();
  return data;
};
